<template>
  <div class="crewHome">
    <div class="crewHome-content" style="overflow: auto">
      <el-form :inline="true" :model="formInline" class="other-form-left">
        <el-form-item label="船舶:" style="margin-left: 10px">
          <el-input
            v-model="formInline.shipName"
            style="width: 100px"
            :readonly="true"
          ></el-input>
        </el-form-item>
        <el-form-item label="月份:">
          <el-input
            v-model="formInline.month"
            style="width: 100px"
            :readonly="true"
          ></el-input>
        </el-form-item>
      </el-form>
      <el-form :inline="true" :model="formInline" class="other-form-inline">
        <el-form-item>
          <div class="other-search3" @click="exportExcel()">导出</div>
        </el-form-item>
      </el-form>
      <div style="clear: both"></div>
      <el-divider class="other-divider"></el-divider>
      <div class="other-table-salary">
        <el-table
          :data="tableData"
          style="width: 100%"
          header-row-class-name="other-header"
          row-class-name="other-row"
          height="100%"
        >
          <el-table-column
            type="index"
            width="60"
            label="序号"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="userName"
            label="船员姓名"
            show-overflow-tooltip
          >
            <!-- <template slot-scope="scope">
              <div @click="watchShip(scope)" class="name">
                {{ scope.row.userName }}
              </div>
            </template> -->
          </el-table-column>
          <el-table-column prop="postName" label="职务" show-overflow-tooltip>
          </el-table-column>
          <el-table-column
            prop="crewType"
            label="船员类型"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <span v-if="scope.row.crewType == 1">自有船员</span>
              <span v-if="scope.row.crewType == 2">外包船员</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="standardSalary"
            label="薪资标准"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            prop="onBoardDays"
            label="在船天数"
            show-overflow-tooltip
          >
            <!-- <template slot-scope="scope">
            <div v-if="paramsInfo.type == 2">
              <el-input
                v-model="scope.row.onBoardDays"
                oninput="value=value.replace(/^\./g, '').replace(/[^\d.]/g,'').replace(/\.{2,}/g,'')"
                size="mini"
                placeholder="请输入"
              ></el-input>
            </div>
            <div v-if="paramsInfo.type == 1">{{ scope.row.onBoardDays }}</div>
          </template> -->
          </el-table-column>
          <el-table-column
            prop="shouldPayCount"
            label="应发工资"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            prop="onBoardDate"
            width="210"
            label="在船日期"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            prop="foodFee"
            width="120"
            label="伙食费"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <div v-if="paramsInfo.type == 2">
                <el-input
                  v-model="scope.row.foodFee"
                  @change="getTotal(scope)"
                  type="number"
                  size="mini"
                  placeholder="请输入"
                ></el-input>
              </div>
              <div v-if="paramsInfo.type == 1">{{ scope.row.foodFee }}</div>
            </template>
          </el-table-column>
          <el-table-column
            prop="approveSalary"
            width="120"
            label="核准工资"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <div v-if="paramsInfo.type == 2">
                <el-input
                  v-model="scope.row.approveSalary"
                  @change="getTotal(scope)"
                  oninput="value=value.replace(/^\./g, '').replace(/[^\d.]/g,'').replace(/\.{2,}/g,'')"
                  size="mini"
                  placeholder="请输入"
                ></el-input>
              </div>
              <div v-if="paramsInfo.type == 1">
                {{ scope.row.approveSalary }}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="award"
            label="奖罚"
            width="100"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <div v-if="paramsInfo.type == 2">
                <el-input
                  v-model="scope.row.award"
                  type="number"
                  @change="getMoney(scope.row)"
                  size="mini"
                  placeholder="请输入"
                ></el-input>
              </div>
              <div v-if="paramsInfo.type == 1">{{ scope.row.award }}</div>
            </template>
          </el-table-column>
          <el-table-column
            prop="userManageFee"
            label="管理费"
            width="100"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            prop="socialSecurityOwner"
            label="社保/商业险"
            min-width="100"
          >
            <template slot-scope="scope">
              <div v-if="paramsInfo.type == 2">
                <!-- <el-select
                  size="mini"
                  @change="getTotal(scope)"
                  v-model="scope.row.socialSecurityOwner"
                  placeholder="社保/商业险"
                  style="width: 100px"
                >
                  <el-option label="1" value="1"></el-option>
                  <el-option label="0" value="0"></el-option>
                </el-select> -->
                <el-input
                  v-model="scope.row.socialSecurityOwner"
                  @change="getTotal(scope)"
                  oninput="value=value.replace(/^\./g, '').replace(/[^\d.]/g,'').replace(/\.{2,}/g,'')"
                  size="mini"
                  placeholder="请输入"
                ></el-input>
              </div>
              <div v-if="paramsInfo.type == 1">
                {{ scope.row.socialSecurityOwner }}
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="remark" label="备注" show-overflow-tooltip>
            <template slot-scope="scope">
              <div v-if="paramsInfo.type == 2">
                <el-input
                  v-model="scope.row.remark"
                  size="mini"
                  placeholder="请输入"
                ></el-input>
              </div>
              <div v-if="paramsInfo.type == 1">{{ scope.row.remark }}</div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div
        class="other-crew-base"
        style="margin-top: 15px; margin-bottom: 15px; margin-left: 15px"
      >
        <div class="other-base-title">
          <span class="other-base-ball"></span>
          工资汇总表
        </div>
      </div>
      <div class="other-table-num">
        <el-table
          :data="moneyList"
          style="width: 100%"
          header-row-class-name="other-header"
          row-class-name="other-row"
          height="100%"
        >
          <el-table-column
            prop="crewType"
            label="船员类型"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <span v-if="scope.row.crewType == 1">自有船员</span>
              <span v-if="scope.row.crewType == 2">外包船员</span>
              <span v-if="scope.row.crewType == 3">全船汇总</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="shipSalarySum"
            label="工资合计"
            width="100"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            prop="outsourcingAssessmentFee"
            label="船舶考核"
            width="100"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <div
                v-if="paramsInfo.type == 1 && scope.row.crewType == '2'"
                @click="awardDet(scope.row.id, 1)"
                class="ovgreen"
              >
                {{ scope.row.outsourcingAssessmentFee }}
              </div>
              <div v-if="paramsInfo.type == 2 && scope.row.crewType == '2'">
                <div class="read-only" @click="addCrewSalary(scope.row, 4)">
                  {{ scope.row.outsourcingAssessmentFee }}
                </div>
              </div>
              <div v-if="scope.row.crewType != '2'">
                {{ scope.row.outsourcingAssessmentFee }}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="managementFee"
            :label="labelVal"
            width="120"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            prop="guestMealFee"
            label="客餐费"
            width="100"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <div
                v-if="paramsInfo.type == 1 && scope.row.crewType == '2'"
                class="ovgreen"
              >
                <!-- @click="awardDet(scope.row.id, 1)" -->
                {{ scope.row.guestMealFee }}
              </div>
              <div v-if="paramsInfo.type == 2 && scope.row.crewType == '2'">
                <div class="read-only" @click="addCrewSalary(scope.row, 5)">
                  {{ scope.row.guestMealFee }}
                </div>
                <!-- <el-input
                  size="mini"
                  @change="getTotal"
                  v-model="scope.row.guestMealFee"
                  oninput="value=value.replace(/^\./g, '').replace(/[^\d.]/g,'').replace(/\.{2,}/g,'')"
                ></el-input> -->
              </div>
              <div v-if="scope.row.crewType != '2'">
                {{ scope.row.guestMealFee }}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="foodFee"
            label="伙食费"
            width="100"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            prop="socialSecurityTotal"
            label="社保"
            width="100"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            prop="transportationFee"
            label="交通费"
            width="100"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <div v-if="paramsInfo.type == 1 && scope.row.crewType == '2'">
                {{ scope.row.transportationFee }}
              </div>

              <div v-if="paramsInfo.type == 2 && scope.row.crewType == '2'">
                <el-input
                  size="mini"
                  @change="getTotal"
                  v-model="scope.row.transportationFee"
                  oninput="value=value.replace(/^\./g, '').replace(/[^\d.]/g,'').replace(/\.{2,}/g,'')"
                ></el-input>
              </div>
              <div v-if="scope.row.crewType != '2'">
                {{ scope.row.transportationFee }}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="energySavingAward"
            label="节能考核奖罚"
            width="120"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <div
                v-if="paramsInfo.type == 1 && scope.row.crewType == '2'"
                class="ovgreen"
                @click="awardDet(scope.row.id, 1)"
              >
                {{ scope.row.energySavingAward }}
              </div>
              <div v-if="paramsInfo.type == 2 && scope.row.crewType == '2'">
                <div class="read-only" @click="addCrewSalary(scope.row, 1)">
                  {{ scope.row.energySavingAward }}
                </div>
              </div>
              <div v-if="scope.row.crewType != '2'">
                {{ scope.row.energySavingAward }}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="excellentCrewAward"
            label="优秀船员奖励"
            width="120"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <div
                v-if="paramsInfo.type == 1 && scope.row.crewType == '2'"
                class="ovgreen"
                @click="awardDet(scope.row.id, 3)"
              >
                {{ scope.row.excellentCrewAward }}
              </div>
              <div v-if="paramsInfo.type == 2 && scope.row.crewType == '2'">
                <div class="read-only" @click="addCrewSalary(scope.row, 3)">
                  {{ scope.row.excellentCrewAward }}
                </div>
              </div>
              <div v-if="scope.row.crewType != '2'">
                {{ scope.row.excellentCrewAward }}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="safetyGroupAward"
            width="100"
            label="其他奖励"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <div
                v-if="paramsInfo.type == 1 && scope.row.crewType == '2'"
                class="ovgreen"
                @click="awardDet(scope.row.id, 2)"
              >
                {{ scope.row.safetyGroupAward }}
              </div>
              <div v-if="paramsInfo.type == 2 && scope.row.crewType == '2'">
                <div class="read-only" @click="addCrewSalary(scope.row, 2)">
                  {{ scope.row.safetyGroupAward }}
                </div>
              </div>
              <div v-if="scope.row.crewType != '2'">
                {{ scope.row.safetyGroupAward }}
              </div>
            </template>
          </el-table-column>
          <!-- <el-table-column
            prop="award"
            label="奖励"
            width="100"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            prop="penaltyDeduction"
            label="扣罚"
            width="100"
            show-overflow-tooltip
          >
          </el-table-column> -->
          <el-table-column
            prop="socialInsuranceSupplement"
            label="社保补差"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <div v-if="paramsInfo.type == 1">
                {{ scope.row.socialInsuranceSupplement }}
              </div>

              <div v-if="paramsInfo.type == 2">
                <el-input
                  @change="getTotal"
                  oninput="value=value.replace(/^\./g, '').replace(/[^\d.]/g,'').replace(/\.{2,}/g,'')"
                  size="mini"
                  v-model="scope.row.socialInsuranceSupplement"
                ></el-input>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="shipSalaryTotal"
            label="总计"
            width="100"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            prop="tax"
            label="增值税"
            width="100"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            prop="taxIncludedTotal"
            label="合计"
            width="100"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            prop="socialSecurityNum"
            label="社保人数"
            width="100"
            show-overflow-tooltip
          >
          </el-table-column>
          <!-- <el-table-column
            prop="salaryPayNum"
            label="发薪人数"
            width="100"
            show-overflow-tooltip
          >
          </el-table-column> -->
          <el-table-column
            prop="salaryPayNum"
            label="发薪人数"
            width="100"
            show-overflow-tooltip
          >
          </el-table-column>
          <!-- <el-table-column
            prop=""
            label="补助"
            width="100"
            show-overflow-tooltip
          >
          </el-table-column> -->
          <el-table-column prop="remark" label="备注" show-overflow-tooltip>
            <template slot-scope="scope">
              <div v-if="paramsInfo.type == 1">
                {{ scope.row.remark }}
              </div>

              <div v-if="paramsInfo.type == 2">
                <el-input size="mini" v-model="scope.row.remark"></el-input>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div
        class="other-crew-base"
        style="margin-top: 15px; margin-bottom: 15px; margin-left: 15px"
      >
        <div class="other-base-title">
          <span class="other-base-ball"></span>
          变更记录
        </div>
      </div>
      <div class="other-change-list">
        <div
          v-for="(item, index) in formInline.recordDOList"
          :key="index"
          class="recordList"
        >
          {{ item.modifyMoneyContent }}
        </div>
      </div>
      <div class="energy-footer cost-footer" v-if="paramsInfo.type == '2'">
        <div class="energy-button1" @click="saveInfo(formInline.approveState)">
          保存
        </div>
        <div class="energy-button2" @click="savePhoto()">制表</div>
      </div>
    </div>
    <el-dialog
      title="操作记录"
      :visible.sync="dialogVisible"
      top="100px"
      width="1224px"
      :before-close="handleClose"
      class="el-pass-dialog"
    >
      <div class="other-table">
        <el-table
          :data="diaData"
          header-row-class-name="other-header"
          row-class-name="other-row"
          height="500px"
        >
          <el-table-column prop="operatorUser" label="修改人" min-width="80">
          </el-table-column>
          <el-table-column
            prop="modifyContent"
            label="修改内容"
            min-width="250"
          >
          </el-table-column>
          <el-table-column prop="operatorTime" label="修改时间" min-width="140">
          </el-table-column>
        </el-table>
      </div>
    </el-dialog>
    <!-- <div style="height: 100px"></div> -->
    <addSalaryAward ref="shipList" @choseShip="choseShip"></addSalaryAward>
  </div>
</template>
<script>
import {
  monthShipSettlementDetail,
  crewAudit,
  updateOrApprove,
  getSpecialRewardRecord,
  pullOwnerShipSalary,
} from "@/apis/index";
import { apiRoot } from "@/config";
import addSalaryAward from "./addSalaryAward";
import bcMath from "./bcMath";
export default {
  components: { addSalaryAward },
  data() {
    return {
      formInline: {},
      tableData: [],
      tableData2: [],
      labelVal: "管理费(10%)",
      currentPage1: 1,
      pageNo: "1",
      total: 0,
      pageSize: 100,
      companyVisible: false,
      jobParams: {},
      remendLoading: false,
      diaList: {},
      dialogVisible: false,
      rules: {
        userState: [
          {
            required: true,
            message: "请选择员工在本派遣机构状态",
            trigger: "blur",
          },
        ],
      },
      paramsInfo: {},
      moneyList: [],
      shipList: [],
      shipList2: [],
      shipList3: [],
      shipList4: [],
      shipList5: [],
      submitLoading: false,
      diaData: [],
      scoialPeople: "",
      salaryFlage: false,
      awardFlag: false,
      foodFeeFlag: false,
      socialSecurityOwnerFlag: false,
      bol: false,
      totalManage: 0,
      shipTax: "新明州12,新明州16,新明州66,新明州28,新明州60,新明州68",
      taxVisible: true,
    };
  },
  mounted() {
    this.getCrewInfoList();
    this.paramsInfo.type = this.$route.params.type;
    this.bol = this.$route.params.bol;
  },
  methods: {
    exportExcel() {
      window.open(
        `${apiRoot}/outsourcing/settlement/monthShipSettlementDetailExport?token=${sessionStorage.getItem(
          "token"
        )}&id=${this.$route.params.id || ""}`
      );
      // this.$router.push("/specialSalaryDetail")
    },
    awardDet(id, type) {
      this.dialogVisible = true;
      this.getData(id, type);
    },
    goback() {
      this.$router.go(-1);
    },
    handleClose() {
      this.dialogVisible = false;
    },
    async getData(id, type) {
      let params = { id: id, rewardType: type };
      const res = await getSpecialRewardRecord(params);
      if (res.code == 1) {
        this.diaData = res.data;
      } else {
        this.$message.error(res.msg);
      }
    },
    onSubmit() {
      this.pageNo = 1;
      this.getCrewInfoList();
    },
    choseCom() {
      this.companyVisible = true;
    },
    async getCrewInfoList() {
      this.moneyList = [];
      let params = {
        id: this.$route.params.id,
      };
      const res = await monthShipSettlementDetail(params);
      this.formInline = res.data;
      if (this.shipTax.indexOf(this.formInline.shipName) > -1) {
        this.taxVisible = false;
      }
      res.data.ismSalaryOutsourcingUserSettlementVOS.forEach((item) => {
        if (this.paramsInfo.type == 2 && !item.approveSalary && this.bol) {
          item.approveSalary = item.shouldPayCount;
        }
        if (
          this.paramsInfo.type == 2 &&
          !item.socialSecurityOwner &&
          this.bol
        ) {
          item.socialSecurityOwner = 1229.47;
        }
      });
      if (res.data.energySavingAwardRelateId) {
        const idsArray = res.data.energySavingAwardRelateId
          .split(",")
          .map((id) => ({ id }));
        this.shipList = idsArray;
      }
      if (res.data.safetyGroupAwardRelateId) {
        const idsArray = res.data.safetyGroupAwardRelateId
          .split(",")
          .map((id) => ({ id }));
        this.shipList2 = idsArray;
      }
      if (res.data.excellentCrewAwardRelateId) {
        const idsArray = res.data.excellentCrewAwardRelateId
          .split(",")
          .map((id) => ({ id }));
        this.shipList3 = idsArray;
      }
      if (res.data.outsourcingAssessmentFeeRelateId) {
        const idsArray = res.data.outsourcingAssessmentFeeRelateId
          .split(",")
          .map((id) => ({ id }));
        this.shipList4 = idsArray;
      }
      if (res.data.guestMealFeeRelateId) {
        const idsArray = res.data.guestMealFeeRelateId
          .split(",")
          .map((id) => ({ id }));
        this.shipList5 = idsArray;
      }
      this.tableData = res.data.ismSalaryOutsourcingUserSettlementVOS;
      res.data.crewType = "2";
      this.moneyList.push(res.data);
      this.labelVal = `管理费(${this.moneyList[0].managementFeeRadio}%)`;
      this.totalManage = 0;
      this.tableData.forEach((item) => {
        if (item.approveSalary) {
          let a =
            (
              item.approveSalary *
              1 *
              this.moneyList[0].managementFeeRadio
            ).toFixed(1) * 1;
          let b = Math.round(a) / 100;
          item.userManageFee = b;
          this.totalManage += item.userManageFee * 1;
        }
      });
      if (this.formInline.ownerIncludeFlag == "1") {
        // this.getPullOwnerShipSalary();
        this.moneyList.push({
          crewType: "1",
          shipSalarySum: this.formInline.ownerShipSalarySum || 0,
          shipSalaryTotal: this.formInline.ownerShipSalaryTotal || 0,
          excellentCrewAward: this.formInline.ownerExcellentCrewAward || 0,
          safetyGroupAward: this.formInline.ownerSafetyGroupAward || 0,
          tax: this.formInline.ownerTax || 0,
          outsourcingAssessmentFee: 0,
          managementFee: 0,
          guestMealFee: 0,
          foodFee: 0,
          socialSecurityTotal: 0,
          transportationFee: 0,
          energySavingAward: 0,
          socialInsuranceSupplement: 0,
          taxIncludedTotal: this.formInline.ownerTaxIncludedTotal || 0,
          socialSecurityNum: this.formInline.ownerSocialSecurityNum || 0,
          salaryPayNum: this.formInline.ownerSalaryPayNum || 0,
        });
        // //  socialInsuranceSupplement tax taxIncludedTotal socialSecurityNum salaryPayNum
        // this.$set(this.moneyList[1], "shipSalarySum", pullTotal.toFixed(2));
        // this.$set(this.moneyList[1], "socialSecurityNum", scoialNum);
        // this.$set(this.moneyList[1], "salaryPayNum", ownData.length);
        // this.$set(this.moneyList[1], "socialSecurityNum", ownData.length);
        // this.moneyList[1].shipSalaryTotal = (
        //   (this.moneyList[1].shipSalarySum || 0) * 1 +
        //   (this.moneyList[1].managementFee || 0) * 1 +
        //   (this.moneyList[1].foodFee || 0) * 1 +
        //   (this.moneyList[1].socialSecurityTotal || 0) * 1 +
        //   (this.moneyList[1].transportationFee || 0) * 1 +
        //   (this.moneyList[1].energySavingAward || 0) * 1 +
        //   (this.moneyList[1].safetyGroupAward || 0) * 1 +
        //   (this.moneyList[1].excellentCrewAward || 0) * 1 +
        //   (this.moneyList[1].socialInsuranceSupplement || 0) * 1 +
        //   (this.moneyList[1].outsourcingAssessmentFee || 0) * 1 +
        //   (this.moneyList[1].guestMealFee || 0) * 1
        // ).toFixed(2);
        // if (!this.checkExists(this.formData.shipName)) {
        //   this.moneyList[1].tax = this.customToFixed(
        //     bcMath.mul([this.moneyList[1].shipSalaryTotal, 0.06]) * 1,
        //     2
        //   );
        //   // console.log(this.moneyList[0].tax, "this.moneyList[0].tax");
        // }

        // this.moneyList[1].taxIncludedTotal = bcMath
        //   .add([this.moneyList[1].tax || 0, this.moneyList[1].shipSalaryTotal])
        //   .toFixed(2);
        this.moneyList.push({
          crewType: "3",
          shipSalaryTotal: (
            this.moneyList[0].shipSalaryTotal * 1 +
            this.moneyList[1].shipSalaryTotal * 1
          ).toFixed(2),
          taxIncludedTotal: (
            this.moneyList[0].taxIncludedTotal * 1 +
            this.moneyList[1].taxIncludedTotal * 1
          ).toFixed(2),
          outsourcingAssessmentFee: (
            this.moneyList[0].outsourcingAssessmentFee * 1 +
            this.moneyList[1].outsourcingAssessmentFee * 1
          ).toFixed(2),
          managementFee: (
            this.moneyList[0].managementFee * 1 +
            this.moneyList[1].managementFee * 1
          ).toFixed(2),
          foodFee: (
            this.moneyList[0].foodFee * 1 +
            this.moneyList[1].foodFee * 1
          ).toFixed(2),
          socialSecurityTotal: (
            this.moneyList[0].socialSecurityTotal * 1 +
            this.moneyList[1].socialSecurityTotal * 1
          ).toFixed(2),
          transportationFee: (
            this.moneyList[0].transportationFee * 1 +
            this.moneyList[1].transportationFee * 1
          ).toFixed(2),
          energySavingAward: (
            this.moneyList[0].energySavingAward * 1 +
            this.moneyList[1].energySavingAward * 1
          ).toFixed(2),
          socialInsuranceSupplement: (
            this.moneyList[0].socialInsuranceSupplement * 1 +
            this.moneyList[1].socialInsuranceSupplement * 1
          ).toFixed(2),
          socialSecurityNum: (
            this.moneyList[0].socialSecurityNum * 1 +
            this.moneyList[1].socialSecurityNum * 1
          ).toFixed(0),
          salaryPayNum: (
            this.moneyList[0].salaryPayNum * 1 +
            this.moneyList[1].salaryPayNum * 1
          ).toFixed(0),
          excellentCrewAward: (
            this.moneyList[0].excellentCrewAward * 1 +
            this.moneyList[1].excellentCrewAward * 1
          ).toFixed(2),
          safetyGroupAward: (
            this.moneyList[0].safetyGroupAward * 1 +
            this.moneyList[1].safetyGroupAward * 1
          ).toFixed(2),
          tax: (this.moneyList[0].tax * 1 + this.moneyList[1].tax * 1).toFixed(
            2
          ),
          shipSalarySum: (
            this.moneyList[0].shipSalarySum * 1 +
            this.moneyList[1].shipSalarySum * 1
          ).toFixed(2),
          guestMealFee: (
            this.moneyList[0].guestMealFee * 1 +
            this.moneyList[1].guestMealFee * 1
          ).toFixed(2),
        });
      }
      // this.getTotal();
      // this.moneyList[0].managementFee = this.totalManage.toFixed(2);
      // if (this.paramsInfo.type == 2) {

      // }

      // this.moneyList[0].shipSalarySum = this.totalNum
      // this.moneyList[0].taxIncludedTotal = this.moneyList[0].tax * 1 + ((this.moneyList[0].shipSalarySum||0)+(this.moneyList[0].managementFee||0)+(this.moneyList[0].foodFee||0)+ (this.moneyList[0].socialSecurityTotal||0)+ (this.moneyList[0].transportationFee||0)).toFixed(2) * 1
    },
    customToFixed(num, precision) {
      const factor = Math.pow(10, precision);
      return (Math.round(num * factor) / factor).toFixed(precision);
    },
    async getPullOwnerShipSalary() {
      const res = await pullOwnerShipSalary({
        id: this.$route.params.id,
      });
      if (res.data && res.data.length > 0) {
        this.tableData = this.tableData.concat(res.data);
      }

      this.pullOwnerList = res.data;
      let pullTotal = 0;
      // let scoialNum = 0;
      // this.pullOwnerList.forEach((item) => {
      //   pullTotal += item.approveSalary * 1;
      //   if (item.socialSecurityOwner > 0) {
      //     scoialNum += 1;
      //   }
      // });
      this.moneyList.push({
        crewType: "1",
        excellentCrewAward: this.formInline.ownerExcellentCrewAward,
        safetyGroupAward: this.formInline.ownerSafetyGroupAward,
        tax: 0,
        outsourcingAssessmentFee: 0,
        managementFee: 0,
        guestMealFee: 0,
        foodFee: 0,
        socialSecurityTotal: 0,
        transportationFee: 0,
        energySavingAward: 0,
        socialInsuranceSupplement: 0,
        taxIncludedTotal: 0,
        socialSecurityNum: 0,
        salaryPayNum: 0,
      });
      this.$set(this.moneyList[1], "shipSalarySum", pullTotal.toFixed(2));
      // this.$set(this.moneyList[1], "socialSecurityNum", scoialNum);
      this.$set(
        this.moneyList[1],
        "socialSecurityNum",
        this.pullOwnerList.length
      );
      this.$set(this.moneyList[1], "salaryPayNum", this.pullOwnerList.length);
      this.moneyList[1].shipSalaryTotal = (
        (this.moneyList[1].shipSalarySum || 0) * 1 +
        (this.moneyList[1].managementFee || 0) * 1 +
        (this.moneyList[1].foodFee || 0) * 1 +
        (this.moneyList[1].socialSecurityTotal || 0) * 1 +
        (this.moneyList[1].transportationFee || 0) * 1 +
        (this.moneyList[1].energySavingAward || 0) * 1 +
        (this.moneyList[1].safetyGroupAward || 0) * 1 +
        (this.moneyList[1].excellentCrewAward || 0) * 1 +
        (this.moneyList[1].socialInsuranceSupplement || 0) * 1 +
        (this.moneyList[1].outsourcingAssessmentFee || 0) * 1 +
        (this.moneyList[1].guestMealFee || 0) * 1
      ).toFixed(2);
      if (this.taxVisible) {
        this.moneyList[1].tax = this.customToFixed(
          this.moneyList[1].shipSalaryTotal * 1 * 0.06 * 1,
          2
        );
      }

      this.moneyList[1].taxIncludedTotal = bcMath
        .add([this.moneyList[1].tax || 0, this.moneyList[1].shipSalaryTotal])
        .toFixed(2);
      this.moneyList.push({
        crewType: "3",
        shipSalaryTotal: (
          this.moneyList[0].shipSalaryTotal * 1 +
          this.moneyList[1].shipSalaryTotal * 1
        ).toFixed(2),
        taxIncludedTotal: (
          this.moneyList[0].taxIncludedTotal * 1 +
          this.moneyList[1].taxIncludedTotal * 1
        ).toFixed(2),
        outsourcingAssessmentFee: (
          this.moneyList[0].outsourcingAssessmentFee * 1 +
          this.moneyList[1].outsourcingAssessmentFee * 1
        ).toFixed(2),
        managementFee: (
          this.moneyList[0].managementFee * 1 +
          this.moneyList[1].managementFee * 1
        ).toFixed(2),
        foodFee: (
          this.moneyList[0].foodFee * 1 +
          this.moneyList[1].foodFee * 1
        ).toFixed(2),
        socialSecurityTotal: (
          this.moneyList[0].socialSecurityTotal * 1 +
          this.moneyList[1].socialSecurityTotal * 1
        ).toFixed(2),
        transportationFee: (
          this.moneyList[0].transportationFee * 1 +
          this.moneyList[1].transportationFee * 1
        ).toFixed(2),
        energySavingAward: (
          this.moneyList[0].energySavingAward * 1 +
          this.moneyList[1].energySavingAward * 1
        ).toFixed(2),
        socialInsuranceSupplement: (
          this.moneyList[0].socialInsuranceSupplement * 1 +
          this.moneyList[1].socialInsuranceSupplement * 1
        ).toFixed(2),
        socialSecurityNum: (
          this.moneyList[0].socialSecurityNum * 1 +
          this.moneyList[1].socialSecurityNum * 1
        ).toFixed(0),
        salaryPayNum: (
          this.moneyList[0].salaryPayNum * 1 +
          this.moneyList[1].salaryPayNum * 1
        ).toFixed(0),
        excellentCrewAward: (
          this.moneyList[0].excellentCrewAward * 1 +
          this.moneyList[1].excellentCrewAward * 1
        ).toFixed(2),
        safetyGroupAward: (
          this.moneyList[0].safetyGroupAward * 1 +
          this.moneyList[1].safetyGroupAward * 1
        ).toFixed(2),
        tax: (this.moneyList[0].tax * 1 + this.moneyList[1].tax * 1).toFixed(2),
        shipSalarySum: (
          this.moneyList[0].shipSalarySum * 1 +
          this.moneyList[1].shipSalarySum * 1
        ).toFixed(2),
        guestMealFee: (
          this.moneyList[0].guestMealFee * 1 +
          this.moneyList[1].guestMealFee * 1
        ).toFixed(2),
      });
      // this.moneyList[1].shipSalarySum = pullTotal.toFixed(2);
      // this.porcessList = res.data;
      // console.log(res);
    },
    choseShip(val) {
      // console.log("111", val);

      if (this.checkType == "1") {
        let singleShip = this.shipList.filter((el) => {
          return el.id.indexOf("、") >= 0;
        });
        this.shipList = val.concat(singleShip);
        this.moneyList[0].energySavingAward = 0;
        this.shipList.forEach((item) => {
          this.moneyList[0].energySavingAward +=
            item.outsourcingRewardCount * 1;
        });
        const idStrings = this.shipList.map((item) => item.id);
        this.moneyList[0].energySavingAwardRelateId = idStrings.join(",");
        // 总计
        this.moneyList[0].shipSalaryTotal = (
          (this.moneyList[0].shipSalarySum || 0) * 1 +
          (this.moneyList[0].managementFee || 0) * 1 +
          (this.moneyList[0].foodFee || 0) * 1 +
          (this.moneyList[0].socialSecurityTotal || 0) * 1 +
          (this.moneyList[0].transportationFee || 0) * 1 +
          (this.moneyList[0].energySavingAward || 0) * 1 +
          (this.moneyList[0].safetyGroupAward || 0) * 1 +
          (this.moneyList[0].excellentCrewAward || 0) * 1 +
          (this.moneyList[0].socialInsuranceSupplement || 0) * 1 +
          (this.moneyList[0].outsourcingAssessmentFee || 0) * 1 +
          (this.moneyList[0].guestMealFee || 0) * 1
        ).toFixed(2);
        if (this.taxVisible) {
          this.moneyList[0].tax = this.customToFixed(
            this.moneyList[0].shipSalaryTotal * 1 * 0.06 * 1,
            2
          );
        }
        this.moneyList[0].taxIncludedTotal = (
          this.moneyList[0].tax * 1 +
          this.moneyList[0].shipSalaryTotal * 1
        ).toFixed(2);
        // this.moneyList[0].shipSalaryTotal =
        //   (this.moneyList[0].shipSalaryTotal * 1 +
        //   this.moneyList[0].energySavingAward).toFixed(2);
      } else if (this.checkType == "2") {
        let singleShip = this.shipList2.filter((el) => {
          return el.id.indexOf("、") >= 0;
        });
        this.shipList2 = val.concat(singleShip);
        this.moneyList[0].safetyGroupAward = 0;
        this.shipList2.forEach((item) => {
          this.moneyList[0].safetyGroupAward += item.outsourcingRewardCount * 1;
        });
        const idStrings = this.shipList2.map((item) => item.id);
        this.moneyList[0].safetyGroupAwardRelateId = idStrings.join(",");
        this.moneyList[0].shipSalaryTotal = (
          (this.moneyList[0].shipSalarySum || 0) * 1 +
          (this.moneyList[0].managementFee || 0) * 1 +
          (this.moneyList[0].foodFee || 0) * 1 +
          (this.moneyList[0].socialSecurityTotal || 0) * 1 +
          (this.moneyList[0].transportationFee || 0) * 1 +
          (this.moneyList[0].energySavingAward || 0) * 1 +
          (this.moneyList[0].safetyGroupAward || 0) * 1 +
          (this.moneyList[0].excellentCrewAward || 0) * 1 +
          (this.moneyList[0].socialInsuranceSupplement || 0) * 1 +
          (this.moneyList[0].outsourcingAssessmentFee || 0) * 1 +
          (this.moneyList[0].guestMealFee || 0) * 1
        ).toFixed(2);
        if (this.taxVisible) {
          this.moneyList[0].tax = this.customToFixed(
            this.moneyList[0].shipSalaryTotal * 1 * 0.06 * 1,
            2
          );
        }

        this.moneyList[0].taxIncludedTotal = (
          this.moneyList[0].tax * 1 +
          this.moneyList[0].shipSalaryTotal * 1
        ).toFixed(2);
        // this.moneyList[0].shipSalaryTotal =
        //   (this.moneyList[0].shipSalaryTotal * 1 +
        //   this.moneyList[0].safetyGroupAward).toFixed(2);
      } else if (this.checkType == "3") {
        let singleShip = this.shipList3.filter((el) => {
          return el.id.indexOf("、") >= 0;
        });
        this.shipList3 = val.concat(singleShip);
        this.moneyList[0].excellentCrewAward = 0;
        this.shipList3.forEach((item) => {
          this.moneyList[0].excellentCrewAward +=
            item.outsourcingRewardCount * 1;
        });
        const idStrings = this.shipList3.map((item) => item.id);
        this.moneyList[0].excellentCrewAwardRelateId = idStrings.join(",");
        this.moneyList[0].shipSalaryTotal = (
          (this.moneyList[0].shipSalarySum || 0) * 1 +
          (this.moneyList[0].managementFee || 0) * 1 +
          (this.moneyList[0].foodFee || 0) * 1 +
          (this.moneyList[0].socialSecurityTotal || 0) * 1 +
          (this.moneyList[0].transportationFee || 0) * 1 +
          (this.moneyList[0].energySavingAward || 0) * 1 +
          (this.moneyList[0].safetyGroupAward || 0) * 1 +
          (this.moneyList[0].excellentCrewAward || 0) * 1 +
          (this.moneyList[0].socialInsuranceSupplement || 0) * 1 +
          (this.moneyList[0].outsourcingAssessmentFee || 0) * 1 +
          (this.moneyList[0].guestMealFee || 0) * 1
        ).toFixed(2);
        if (this.taxVisible) {
          this.moneyList[0].tax = this.customToFixed(
            this.moneyList[0].shipSalaryTotal * 1 * 0.06 * 1,
            2
          );
        }
        this.moneyList[0].taxIncludedTotal = (
          this.moneyList[0].tax * 1 +
          this.moneyList[0].shipSalaryTotal * 1
        ).toFixed(2);
        // this.moneyList[0].shipSalaryTotal =
        //   (this.moneyList[0].shipSalaryTotal * 1 +
        //   this.moneyList[0].excellentCrewAward).toFixed(2);
      } else if (this.checkType == "4") {
        let singleShip = this.shipList4.filter((el) => {
          return el.id.indexOf("、") >= 0;
        });
        this.shipList4 = val.concat(singleShip);
        this.moneyList[0].outsourcingAssessmentFee = 0;
        this.shipList4.forEach((item) => {
          this.moneyList[0].outsourcingAssessmentFee +=
            item.outsourcingRewardCount * 1;
        });
        const idStrings = this.shipList4.map((item) => item.id);
        this.moneyList[0].outsourcingAssessmentFeeRelateId =
          idStrings.join(",");
        this.moneyList[0].shipSalaryTotal = (
          (this.moneyList[0].shipSalarySum || 0) * 1 +
          (this.moneyList[0].managementFee || 0) * 1 +
          (this.moneyList[0].foodFee || 0) * 1 +
          (this.moneyList[0].socialSecurityTotal || 0) * 1 +
          (this.moneyList[0].transportationFee || 0) * 1 +
          (this.moneyList[0].energySavingAward || 0) * 1 +
          (this.moneyList[0].safetyGroupAward || 0) * 1 +
          (this.moneyList[0].excellentCrewAward || 0) * 1 +
          (this.moneyList[0].socialInsuranceSupplement || 0) * 1 +
          (this.moneyList[0].outsourcingAssessmentFee || 0) * 1 +
          (this.moneyList[0].guestMealFee || 0) * 1
        ).toFixed(2);
        this.moneyList[0].tax = this.customToFixed(
          this.moneyList[0].shipSalaryTotal * 1 * 0.06 * 1,
          2
        );
        this.moneyList[0].taxIncludedTotal = (
          this.moneyList[0].tax * 1 +
          this.moneyList[0].shipSalaryTotal * 1
        ).toFixed(2);
        // this.moneyList[0].shipSalaryTotal =
        //   (this.moneyList[0].shipSalaryTotal * 1 +
        //   this.moneyList[0].excellentCrewAward).toFixed(2);
      } else if (this.checkType == "5") {
        let singleShip = this.shipList5.filter((el) => {
          return el.id.indexOf("、") >= 0;
        });
        this.shipList5 = val.concat(singleShip);
        this.moneyList[0].guestMealFee = 0;
        this.shipList5.forEach((item) => {
          this.moneyList[0].guestMealFee += item.outsourcingRewardCount * 1;
        });
        const idStrings = this.shipList5.map((item) => item.id);
        this.moneyList[0].guestMealFeeRelateId = idStrings.join(",");
        this.moneyList[0].shipSalaryTotal = (
          (this.moneyList[0].shipSalarySum || 0) * 1 +
          (this.moneyList[0].managementFee || 0) * 1 +
          (this.moneyList[0].foodFee || 0) * 1 +
          (this.moneyList[0].socialSecurityTotal || 0) * 1 +
          (this.moneyList[0].transportationFee || 0) * 1 +
          (this.moneyList[0].energySavingAward || 0) * 1 +
          (this.moneyList[0].safetyGroupAward || 0) * 1 +
          (this.moneyList[0].excellentCrewAward || 0) * 1 +
          (this.moneyList[0].socialInsuranceSupplement || 0) * 1 +
          (this.moneyList[0].outsourcingAssessmentFee || 0) * 1 +
          (this.moneyList[0].guestMealFee || 0) * 1
        ).toFixed(2);
        this.moneyList[0].tax = this.customToFixed(
          this.moneyList[0].shipSalaryTotal * 1 * 0.06 * 1,
          2
        );
        this.moneyList[0].taxIncludedTotal = (
          this.moneyList[0].tax * 1 +
          this.moneyList[0].shipSalaryTotal * 1
        ).toFixed(2);
        // this.moneyList[0].shipSalaryTotal =
        //   (this.moneyList[0].shipSalaryTotal * 1 +
        //   this.moneyList[0].excellentCrewAward).toFixed(2);
      }
    },
    delInvite(scope) {
      this.$confirm("确定要淘汰吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          // 执行删除操作
          // this.$message({
          //   message: "删除成功",
          //   type: "success",
          // });
          this.delList(scope.row);
          // console.log(scope);
        })
        .catch(() => {
          // 取消删除操作
          console.log("取消删除");
        });
    },
    async delList(row) {
      await crewAudit({
        agentAuditState: "3",
        userId: row.userId,
        agentCyAuditId: row.agentCyAuditId,
        userOrigin: "2",
      });
      // console.log(res);
      this.getCrewInfoList();
    },
    passInvite(scope) {
      this.jobParams = {};
      this.diaList = scope.row;
      this.companyVisible = true;
    },
    rememendCrewPass() {
      if (!this.jobParams.userState) {
        this.$message({
          message: "请选择是否属于本公司",
          type: "error",
        });
        return;
      }
      this.remendLoading = true;
      this.addCrewList();
    },
    async addCrewList() {
      let res = await crewAudit({
        userState: this.jobParams.userState,
        crewType: this.jobParams.crewType,
        agentAuditState: "2",
        userId: this.diaList.userId,
        agentCyAuditId: this.diaList.agentCyAuditId,
        userOrigin: "2",
      });
      if (res.code == 1) {
        this.$message({
          message: "成功",
          type: "success",
        });
        this.remendLoading = false;
        this.companyVisible = false;
        this.getCrewInfoList();
        // this.$router.push({ name: "邀请船员" });
      } else {
        this.$message({
          message: res.msg,
          type: "warning",
        });
        this.remendLoading = false;
        this.companyVisible = false;
      }
      // console.log(res);
    },
    getTotal() {
      this.totalNum = 0;
      this.moneyNum = 0;
      this.foodNum = 0;
      this.scoialNum = 0;
      this.scoialPeople = 0;
      this.totalManage = 0;
      this.tableData.forEach((item) => {
        if (item.approveSalary) {
          this.totalNum += item.approveSalary * 1;
          let a =
            bcMath.mul([
              item.approveSalary * 1,
              this.moneyList[0].managementFeeRadio,
            ]) / 100;
          let b = this.customToFixed(a, 2);
          item.userManageFee = b;
          this.totalManage += item.userManageFee * 1;
        }
        if (item.award) {
          this.moneyNum += item.award * 1;
        }
        if (item.foodFee) {
          this.foodNum += item.foodFee * 1;
        }
        // if (item.socialSecurityOwner) {
        //   this.scoialNum += item.socialSecurityOwner * 1;
        // }
        if (item.socialSecurityOwner) {
          this.scoialNum += item.socialSecurityOwner * 1;
        }
        if (item.socialSecurityOwner > 0) {
          this.scoialPeople += 1;
        }
      });
      this.moneyList[0].shipSalarySum = this.totalNum;
      this.moneyList[0].award = this.moneyNum;
      this.moneyList[0].foodFee = this.foodNum;
      this.moneyList[0].socialSecurityNum = this.scoialPeople;
      this.moneyList[0].socialSecurityTotal = this.scoialNum.toFixed(2);
      this.moneyList[0].managementFee = this.totalManage.toFixed(2);
      this.moneyList[0].shipSalaryTotal = (
        (this.moneyList[0].shipSalarySum || 0) * 1 +
        (this.moneyList[0].managementFee || 0) * 1 +
        (this.moneyList[0].foodFee || 0) * 1 +
        (this.moneyList[0].socialSecurityTotal || 0) * 1 +
        (this.moneyList[0].transportationFee || 0) * 1 +
        (this.moneyList[0].energySavingAward || 0) * 1 +
        (this.moneyList[0].safetyGroupAward || 0) * 1 +
        (this.moneyList[0].excellentCrewAward || 0) * 1 +
        (this.moneyList[0].socialInsuranceSupplement || 0) * 1 +
        (this.moneyList[0].outsourcingAssessmentFee || 0) * 1 +
        (this.moneyList[0].guestMealFee || 0) * 1
      ).toFixed(2);
      if (this.taxVisible) {
        this.moneyList[0].tax = this.customToFixed(
          this.moneyList[0].shipSalaryTotal * 1 * 0.06 * 1,
          2
        );
      }
      this.moneyList[0].taxIncludedTotal = (
        this.moneyList[0].tax * 1 +
        this.moneyList[0].shipSalaryTotal * 1
      ).toFixed(2);
    },
    getMoney(row) {
      let moneySend = row.award;
      let moneySalary = row.shouldPayCount;
      row.approveSalary = moneySalary * 1 + moneySend * 1;
      this.getTotal();
      // this.moneyNum = 0;
      // this.tableData.forEach((item) => {
      //   if (item.award) {
      //     this.moneyNum += item.award * 1;
      //   }
      // });
      // this.moneyList[0].award = this.moneyNum;
    },
    addCrewSalary(row, type) {
      if (type == 1) {
        let list = this.shipList.filter((val) => {
          return val.id.indexOf("、") < 0;
        });
        // let type = "2"
        row.type = type;
        this.checkType = type;
        this.$refs.shipList.showToggle(list, row);
      } else if (type == 2) {
        console.log(this.shipList2);
        let list = this.shipList2.filter((val) => {
          return val.id.indexOf("、") < 0;
        });
        // let type = "2"
        row.type = type;
        this.checkType = type;
        this.$refs.shipList.showToggle(list, row);
      } else if (type == 3) {
        console.log(this.shipList3);
        let list = this.shipList3.filter((val) => {
          return val.id.indexOf("、") < 0;
        });
        // let type = "2"
        row.type = type;
        this.checkType = type;
        this.$refs.shipList.showToggle(list, row);
      } else if (type == 4) {
        let list = this.shipList4.filter((val) => {
          return val.id.indexOf("、") < 0;
        });
        // let type = "2"
        row.type = type;
        this.checkType = type;
        this.$refs.shipList.showToggle(list, row);
      } else if (type == 5) {
        let list = this.shipList5.filter((val) => {
          return val.id.indexOf("、") < 0;
        });
        // let type = "2"
        row.type = type;
        this.checkType = type;
        this.$refs.shipList.showToggle(list, row);
      }
    },
    savePhoto() {
      this.$confirm("是否制表？(制表后数据将推送至宁远端)", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.saveInfo(1);
        })
        .catch(() => {
          // 取消删除操作
          console.log("取消删除");
        });
    },
    async saveInfo(type) {
      if (this.submitLoading == true) {
        return;
      }
      this.salaryFlage = false;
      this.awardFlag = false;
      this.foodFeeFlag = false;
      this.socialSecurityOwnerFlag = false;
      this.tableData.forEach((item) => {
        if (!item.approveSalary && item.approveSalary != "0") {
          this.salaryFlage = true;
        }
        if (!item.award && item.award != "0") {
          this.awardFlag = true;
        }
        if (!item.foodFee && item.foodFee != "0") {
          this.foodFeeFlag = true;
        }
        if (!item.socialSecurityOwner && item.socialSecurityOwner != "0") {
          this.socialSecurityOwnerFlag = true;
        }
      });
      if (this.salaryFlage) {
        this.$message.warning("核准工资不能为空");
        return;
      }
      if (this.awardFlag) {
        this.$message.warning("奖罚不能为空");
        return;
      }
      if (this.foodFeeFlag) {
        this.$message.warning("伙食费不能为空");
        return;
      }
      if (this.socialSecurityOwnerFlag) {
        this.$message.warning("社保/商业险不能为空");
        return;
      }
      let params = this.formInline;
      this.submitLoading = true;
      params.ismSalaryOutsourcingUserSettlementVOS = this.tableData;
      params.shipSalarySum = this.moneyList.length
        ? this.moneyList[0].shipSalarySum
        : 0;
      params.managementFee = this.moneyList.length
        ? this.moneyList[0].managementFee
        : 0;
      params.foodFee = this.moneyList.length ? this.moneyList[0].foodFee : 0;
      params.socialSecurityTotal = this.moneyList.length
        ? this.moneyList[0].socialSecurityTotal
        : 0;
      params.transportationFee = this.moneyList.length
        ? this.moneyList[0].transportationFee
        : 0;
      params.shipSalarySum = this.moneyList.length
        ? this.moneyList[0].shipSalarySum
        : 0;
      params.tax = this.moneyList.length ? this.moneyList[0].tax : 0;
      params.taxIncludedTotal = this.moneyList.length
        ? this.moneyList[0].taxIncludedTotal
        : 0;
      params.award = this.moneyList.length ? this.moneyList[0].award : 0;
      params.penaltyDeduction = this.moneyList.length
        ? this.moneyList[0].penaltyDeduction
        : 0;
      params.socialSecurityNum = this.moneyList.length
        ? this.moneyList[0].socialSecurityNum
        : 0;
      params.salaryPayNum = this.moneyList.length
        ? this.moneyList[0].salaryPayNum
        : 0;
      params.excellentCrewAwardRelateId = this.moneyList.length
        ? this.moneyList[0].excellentCrewAwardRelateId
        : "";
      params.energySavingAwardRelateId = this.moneyList.length
        ? this.moneyList[0].energySavingAwardRelateId
        : "";
      params.safetyGroupAwardRelateId = this.moneyList.length
        ? this.moneyList[0].safetyGroupAwardRelateId
        : "";
      params.energySavingAward = this.moneyList.length
        ? this.moneyList[0].energySavingAward
        : 0;
      params.outsourcingAssessmentFee = this.moneyList.length
        ? this.moneyList[0].outsourcingAssessmentFee
        : 0;
      params.guestMealFee = this.moneyList.length
        ? this.moneyList[0].guestMealFee
        : 0;
      params.outsourcingAssessmentFeeRelateId = this.moneyList.length
        ? this.moneyList[0].outsourcingAssessmentFeeRelateId
        : 0;
      params.guestMealFeeRelateId = this.moneyList.length
        ? this.moneyList[0].guestMealFeeRelateId
        : 0;
      params.safetyGroupAward = this.moneyList.length
        ? this.moneyList[0].safetyGroupAward
        : 0;
      params.excellentCrewAward = this.moneyList.length
        ? this.moneyList[0].excellentCrewAward
        : 0;
      params.approveState = type;
      const res = await updateOrApprove(params);
      if (res.code == 1) {
        if (type != "1") {
          this.$message.success("保存成功");
        } else {
          this.$message.success("制表成功");
        }

        this.$router.go(-1);
        this.submitLoading = false;
      } else {
        this.submitLoading = false;
        this.$message.success(res.msg);
      }
    },
  },
};
</script>
<style lang="scss" scoped>
::-webkit-scrollbar {
  width: 0.5em;
  height: 0.5em;
}

/* 隐藏滚动条轨道 */
::-webkit-scrollbar-track {
  background-color: transparent;
}

/* 隐藏滚动条滑块 */
::-webkit-scrollbar-thumb {
  background-color: transparent;
}
</style>
